export const IStatus = {
    DRAFT: 0,
    ENABLE: 1,
    DISABLE: 2
}